import { Component } from '@angular/core';

@Component({
  selector: 'icon-pencil-with-line-2',
  templateUrl: './icon-pencil-with-line-2.component.html',
  styleUrls: ['./icon-pencil-with-line-2.component.sass']
})
export class IconPencilWithLine2Component {}
